import { lazy } from 'react';

export const LazySlidesBanner = lazy(() => import('./components/slides-banner'));
